import { Api as api } from "../api";
const prefix = "system-config";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    systemConfigServiceV1HealthCheck: build.query<
      SystemConfigServiceV1HealthCheckApiResponse,
      SystemConfigServiceV1HealthCheckApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/health`,
        params: {
          source: queryArg.source,
        },
      }),
    }),
    systemConfigServiceV1GetLoaConfigsByWorkspaceAndCompany: build.query<
      SystemConfigServiceV1GetLoaConfigsByWorkspaceAndCompanyApiResponse,
      SystemConfigServiceV1GetLoaConfigsByWorkspaceAndCompanyApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/loa-configs/workspace/${queryArg.typeCode}`,
        params: {
          page: queryArg.page,
          limit: queryArg.limit,
        },
      }),
    }),
    systemConfigServiceV1ActivateLoaConfig: build.mutation<
      SystemConfigServiceV1ActivateLoaConfigApiResponse,
      SystemConfigServiceV1ActivateLoaConfigApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/loa-configs/${queryArg.id}/active`,
        method: "PATCH",
      }),
    }),
    systemConfigServiceV1DeactiveLoaConfig: build.mutation<
      SystemConfigServiceV1DeactiveLoaConfigApiResponse,
      SystemConfigServiceV1DeactiveLoaConfigApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/loa-configs/${queryArg.id}/deactive`,
        method: "PATCH",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as systemConfigApi };
export type SystemConfigServiceV1HealthCheckApiResponse =
  /** status 200 A successful response. */ SystemConfigSystemConfigHealthCheckResponse;
export type SystemConfigServiceV1HealthCheckApiArg = {
  source: string;
};
export type SystemConfigServiceV1GetLoaConfigsByWorkspaceAndCompanyApiResponse =
  /** status 200 A successful response. */ SystemConfigGetLoaConfigsByWorkspaceAndCompanyResponse;
export type SystemConfigServiceV1GetLoaConfigsByWorkspaceAndCompanyApiArg = {
  typeCode: string;
  page?: number;
  limit?: number;
};
export type SystemConfigServiceV1ActivateLoaConfigApiResponse =
  /** status 200 A successful response. */ SystemConfigToggleLoaConfigResponse;
export type SystemConfigServiceV1ActivateLoaConfigApiArg = {
  id: string;
};
export type SystemConfigServiceV1DeactiveLoaConfigApiResponse =
  /** status 200 A successful response. */ SystemConfigToggleLoaConfigResponse;
export type SystemConfigServiceV1DeactiveLoaConfigApiArg = {
  id: string;
};
export type SystemConfigSystemConfigHealthCheckResponse = {
  status?: string;
  message?: string;
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type SystemConfigLoaConfigItem = {
  id?: string;
  flow_id?: string;
  code?: string;
  name?: string;
  workspace_type_code?: string;
  type?: string;
  is_active?: boolean;
  configs?: object;
};
export type SystemConfigLoaConfigPaginationMetadata = {
  current_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
  limit?: number;
  total?: number;
  total_page?: number;
};
export type SystemConfigGetLoaConfigsByWorkspaceAndCompanyResponse = {
  data?: SystemConfigLoaConfigItem[];
  metadata?: SystemConfigLoaConfigPaginationMetadata;
};
export type SystemConfigToggleLoaConfigResponse = {
  message?: string;
  success?: boolean;
};
export const {
  useSystemConfigServiceV1HealthCheckQuery,
  useSystemConfigServiceV1GetLoaConfigsByWorkspaceAndCompanyQuery,
  useSystemConfigServiceV1ActivateLoaConfigMutation,
  useSystemConfigServiceV1DeactiveLoaConfigMutation,
} = injectedRtkApi;
